export class WebsocketAdapter {
  constructor(url) {
    this.url = url;
    this.ws = null;
    this.onOpenCallback = null;
    this.onLinkCallback = null;
    this.onMessageCallback = null;
    this.onEndConversationCallback = null;
  }

  connect() {
    this.ws = new WebSocket(this.url);
    this.ws.onopen = () => {
      if (this.onOpenCallback) this.onOpenCallback();
    };
    this.ws.onmessage = (data) => {
      const socketAction = JSON.parse(data.data);
      if (socketAction.action === 'link') {
        if (this.onLinkCallback) this.onLinkCallback(socketAction);
      } else if (socketAction.action === 'end_conversation') {
        if (this.onEndConversationCallback) {
          this.onEndConversationCallback(socketAction);
        }
      } else if (socketAction.action === 'message') {
        if (this.onMessageCallback) this.onMessageCallback(socketAction.data);
      }
    };
    this.ws.onerror = () => {
      if (this.ws) this.ws.close();
      setTimeout(() => {
        this.connect();
      }, 1000);
    };
    this.ws.onclose = () => {
      console.log('closed connection');
      this.connect();
    };
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  sendMessage(socketMessage) {
    this.ws.send(JSON.stringify(socketMessage));
  }

  onOpen(callback) {
    this.onOpenCallback = callback;
  }

  onLink(callback) {
    this.onLinkCallback = callback;
  }

  onMessage(callback) {
    this.onMessageCallback = callback;
  }

  onEndConversation(callback) {
    this.onEndConversationCallback = callback;
  }
}
